// extracted by mini-css-extract-plugin
module.exports = {"navlink":"Navegador_navlink__1q0Lj","navlinkActive":"Navegador_navlinkActive__2d5Rg"};